import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleInsuranceDto } from '../../../vehicle-insurances/dtos/create-vehicle-insurance.dto';
import { UpdateVehicleInsuranceDto } from '../../../vehicle-insurances/dtos/update-vehicle-insurance.dto';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleInsuranceDto | UpdateVehicleInsuranceDto,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	// // Validate
	// const { error } = update....Schema().validate(record, {
	// 	abortEarly,
	// });

	// // Check
	// if (error) {
	// 	return {
	// 		isValid: false,
	// 		errors: error.details?.map((e) => e.message),
	// 	};
	// }

	// Return
	return { isValid: true };
};
